import { fetchWrapper } from '../helpers';

export const companyService = {
	getById,
	add,
	create,
	delete: _delete,
	getCatalogForm,
	getCompanies,
	getAlsoViewed,
	claimProfile
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/company`;
const baseUrlAPI = `${process.env.API_BASE_URL}`;

function getById(id) {
	return fetchWrapper.get(`${baseUrl}?id=${id}`);
}

function add(params) {
	return fetchWrapper.post(baseUrl, params);
}

function create(params) {
	return fetchWrapper.put(baseUrl, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
	return fetchWrapper.delete(`${baseUrl}?id=${id}`);
}

// API
function getCatalogForm() {
	return fetchWrapper.get(`${baseUrlAPI}/form/company`);
}

function getCompanies() {
	return fetchWrapper.get(`${baseUrlAPI}/companies`);
}

function getAlsoViewed(slug) {
	return fetchWrapper.get(`${baseUrlAPI}/company/${slug}/also-viewed`);
}

function claimProfile(companyId, claimData) {
	return fetchWrapper.post(`${baseUrlAPI}/company/${companyId}/claim-request`, claimData);
}